/** This class contains all the paths of the routes which are used inside root module routes */

export class RootRoutePaths {
    // Account child paths
    static readonly FEATURE_ROUTE_BASE_EMPTY_PATH = "";
    static readonly ACCOUNT = "account";
    static readonly UPDATE_TASK = "update-task";
    static readonly TASKMASTER = "taskmaster";
    static readonly IMMEDIATE_ATTENTION = "ImmediateAttention";
    static readonly COMMENT = "comment";
    static readonly MEET = "vijayi-meet";
    static readonly TIMESHEET = "timesheet";
    // static readonly MYTASKBOARD = "mytaskboard";
    static readonly BOARD_VIEW = "board-view";
    static readonly STICKY_NOTES = "sticky-notes";
    static readonly ENTITY_COMMENTS = "task-comments";
    static readonly MEETINGS = "meetings";
    static readonly MANAGE_MEETINGS = "manage-meetings";
    static readonly DASHBOARD = "dashboard";
    static readonly WORKFLOW = "workflow";

    // Other paths
    static readonly AUTH = "auth";
    static readonly LOGIN = "login";
    static readonly REGISTRATION = "register";
    static readonly ROOT = "";
    static readonly HOME = "home";
    static readonly ADMIN = "admin";
    static readonly TASK_MANAGEMENT: string = "task-management";
    static readonly LEAVE_WORKFLOW: string = "leave-workflow";
    static readonly MEETINGS_WORKFLOW = "meetings-workflow";
    static readonly TIMELINE_VIEW = "timeline-view";
    static readonly PRIVACY_POLICY = "privacy-policy";
    static readonly TERMS_AND_CONDITIONS = "terms-and-conditions";
    static readonly ATTENDANCE = "attendance";
    static readonly ADD_TO_TEAM_BY_INVITE = "addToTeamByInvite";
    static readonly TEMPLATES = "templates";
    static readonly USER_ALERTS = "user-alerts";
    static readonly PERFORMANCE_FEEDBACKS: string = "performance-feedbacks";
    static readonly EPICS_HOME: string = "epics";
    static readonly SUPER_ADMIN = "super-admin";
    static readonly JIRA_UPLOAD = "jira-integration";
    static readonly INTEGRATE_GITHUB = "integrate-github";
    static readonly GEO_FENCE_ADMIN = "geo-fence-admin";
    static readonly GEO_FENCE_ATTENDANCE = "geo-fence-tracking";
    static readonly OVERTIME_WORKFLOW: string = "overtime";
    static readonly RELEASES_HOME: string = "releases";

    static readonly SETTINGS = "settings";

    // Document module
    static readonly DOCUMENTS = "documents";
}

/** This class contains all the paths of the features which are used inside feature module routes */

export class FeaturesPaths {
    static readonly MY_TIMESHEET = "my";
    static readonly TEAM_TIMESHEET = "team";
    static readonly DASHBOARD = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.DASHBOARD;
    static readonly UPDATE_TASK = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.UPDATE_TASK;
    // static readonly TASKMASTER = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.TASKMASTER;
    static readonly TASKMASTER = RootRoutePaths.TASKMASTER;
    static readonly IMMEDIATE_ATTENTION = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.IMMEDIATE_ATTENTION;
    static readonly COMMENT = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.COMMENT;
    static readonly MEET = RootRoutePaths.MEET;
    static readonly MYTIMESHEET = RootRoutePaths.TIMESHEET + "/" + FeaturesPaths.MY_TIMESHEET;
    static readonly TIMESHEET = RootRoutePaths.TIMESHEET + "/" + FeaturesPaths.TEAM_TIMESHEET;
    static readonly MYTASKBOARD = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.BOARD_VIEW;
    static readonly BOARD_VIEW = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.BOARD_VIEW;
    static readonly STICKY_NOTES = RootRoutePaths.STICKY_NOTES;
    static readonly LOGIN = RootRoutePaths.LOGIN;
    static readonly REGISTRATION = RootRoutePaths.REGISTRATION;
    static readonly ENTITY_COMMENTS = RootRoutePaths.ENTITY_COMMENTS;
    static readonly GROUP_CONVERSATIONS = "conversation";
    static readonly TASK_COMMENTS = RootRoutePaths.ENTITY_COMMENTS;
    static readonly USER_PROFILE = "user-profile";
    static readonly CHAT_COMMANDS = "chat-commands";
    static readonly MANAGE_USERS = "manage-users";
    static readonly MANAGE_ORGANIZATION = "manage-organization";
    static readonly MANAGE_TEAM_MEMBERS = "manage-team-members";
    static readonly CREATE_TEAM = "create-team";
    static readonly EDIT_TEAM = "edit-team";
    static readonly TASK_DEPENDENCIES = "dependencies";
    static readonly MY_MEETINGS = "my-meetings";
    static readonly MANAGE_MEETINGS = "manage-meetings";
    static readonly PROJECTS = "projects";
    static readonly SPRINTS = "sprints";
    static readonly PERSONAL_ORGANIZATION = "personal-organization";
    static readonly USER_RECIVED_ALERTS = "received";
    static readonly USER_SENT_ALERTS = "sent";

    static readonly LOGIN_NEW = "login";
    static readonly REGISTRATION_NEW = "register";
    static readonly COMPLETE_REGISTRATION = "complete-registration"
    static readonly VERIFY = "verify"
    static readonly PERSONAL_TASK = "personal-tasks";
    static readonly MANAGE_TEAMS = "manage-teams";

    static readonly SUPER_ADMIN_USERS = "users";
    static readonly SUPER_ADMIN_ORGANIZATIONS = "organizations";
    static readonly SUPER_ADMIN_DOMAINS = "domains";
    static readonly SUPER_ADMIN_EXCEPTIONAL_REGISTRATIONS = "exceptional-registrations";
    static readonly BLOCKED_USERS = "blocked-users";
    static readonly APPLICATION_REPORT = "application-report";
    static readonly CONVERSATION = "conversation";
    static readonly GEO_FENCE_ADMIN_DASHBOARD = "dashboard";
    static readonly GEO_FENCE_POLICIES = "policies";
    static readonly SETTINGS = "settings";
    static readonly PROFILE_SETTINGS = "profile";
    static readonly PREFERENCES = "preferences";
    static readonly INTEGRATE_GITHUB = "integrate-github"
    static readonly JIRA_UPLOAD = "jira-integration"
    static readonly WORKFLOW = "workflow";
}

/** This class contains all the actual paths of feature which are used tp redirect user on specific url */

export class ActualURLPaths {
    static readonly LOGIN = RootRoutePaths.AUTH + "/" + FeaturesPaths.LOGIN_NEW;
    static readonly REGISTRATION = RootRoutePaths.AUTH + "/" + FeaturesPaths.REGISTRATION_NEW;
    static readonly COMPLETE_REGISTRATION = RootRoutePaths.AUTH + "/" + FeaturesPaths.COMPLETE_REGISTRATION;

    static readonly CREATE_TEAM = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.CREATE_TEAM;
    static readonly EDIT_TEAM = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.EDIT_TEAM;
    static readonly MANAGE_TEAM = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.MANAGE_TEAMS;
    static readonly MANAGE_USERS = RootRoutePaths.ADMIN + "/" + FeaturesPaths.MANAGE_USERS;
    static readonly MANAGE_ORG_MEMBERS = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.MANAGE_ORGANIZATION;
    static readonly MANAGE_TEAM_MEMBERS = RootRoutePaths.ADMIN + "/" + FeaturesPaths.MANAGE_TEAM_MEMBERS;
    static readonly TASK_DEPENDEDNCIES = RootRoutePaths.TASK_MANAGEMENT + "/" + FeaturesPaths.TASK_DEPENDENCIES;
    static readonly DASHBOARD = RootRoutePaths.ACCOUNT + "/" + RootRoutePaths.DASHBOARD;
    static readonly LEAVE_WORKFLOW = RootRoutePaths.LEAVE_WORKFLOW;
    static readonly MY_MEETINGS = RootRoutePaths.MEETINGS_WORKFLOW + "/" + FeaturesPaths.MY_MEETINGS;
    static readonly MANAGE_MEETINGS = RootRoutePaths.MEETINGS_WORKFLOW + "/" + FeaturesPaths.MANAGE_MEETINGS;
    static readonly TIMELINE_VIEW = RootRoutePaths.TIMELINE_VIEW;
    static readonly PROJECTS = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.PROJECTS;
    static readonly SPRINTS = RootRoutePaths.ADMIN + "/" + FeaturesPaths.SPRINTS;
    static readonly ATTENDANCE = "attendance";
    static readonly PERSONAL_ORGANIZATION = RootRoutePaths.ADMIN + "/" + FeaturesPaths.PERSONAL_ORGANIZATION;
    static readonly USER_ALERTS = RootRoutePaths.USER_ALERTS;
    static readonly USER_RECIVED_ALERTS = RootRoutePaths.USER_ALERTS + "/" + FeaturesPaths.USER_RECIVED_ALERTS;
    static readonly USER_SENT_ALERTS = RootRoutePaths.USER_ALERTS + "/" + FeaturesPaths.USER_SENT_ALERTS;
    static readonly PERFORMANCE_FEEDBACKS = RootRoutePaths.PERFORMANCE_FEEDBACKS;
    static readonly MANAGE_TEAMS = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.MANAGE_TEAMS;
    static readonly EPICS_HOME = RootRoutePaths.EPICS_HOME;
    static readonly SUPER_ADMIN = RootRoutePaths.SUPER_ADMIN;
    static readonly SUPER_ADMIN_USERS = RootRoutePaths.SUPER_ADMIN + "/" + FeaturesPaths.SUPER_ADMIN_USERS;
    static readonly SUPER_ADMIN_ORGANIZATIONS =
        RootRoutePaths.SUPER_ADMIN + "/" + FeaturesPaths.SUPER_ADMIN_ORGANIZATIONS;
    static readonly SUPER_ADMIN_DOMAINS = RootRoutePaths.SUPER_ADMIN + "/" + FeaturesPaths.SUPER_ADMIN_DOMAINS;
    static readonly SUPER_ADMIN_EXCEPTIONAL_REGISTRATIONS =
        RootRoutePaths.SUPER_ADMIN + "/" + FeaturesPaths.SUPER_ADMIN_EXCEPTIONAL_REGISTRATIONS;
    static readonly TEAM_TIMESHEET = RootRoutePaths.ACCOUNT + "/" + FeaturesPaths.TEAM_TIMESHEET;
    static readonly MY_TIMESHEET = RootRoutePaths.ACCOUNT + "/" + FeaturesPaths.MY_TIMESHEET;
    static readonly JIRA_UPLOAD = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.JIRA_UPLOAD;
    static readonly INTEGRATE_GITHUB = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.INTEGRATE_GITHUB;
    static readonly GEO_FENCE_ADMIN_DASHBOARD = RootRoutePaths.GEO_FENCE_ADMIN;
    static readonly GEO_FENCE_POLICIES = RootRoutePaths.GEO_FENCE_ADMIN + "/" + FeaturesPaths.GEO_FENCE_POLICIES;
    static readonly GEO_FENCE_ATTENDANCE = RootRoutePaths.GEO_FENCE_ATTENDANCE;
    static readonly SETTINGS = RootRoutePaths.SETTINGS;
    static readonly PROFILE_SETTINGS = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.PROFILE_SETTINGS;
    static readonly PREFERENCES = RootRoutePaths.SETTINGS + "/" + FeaturesPaths.PREFERENCES;
    static readonly OVERTIME_WORKFLOW = RootRoutePaths.OVERTIME_WORKFLOW;
    static readonly RELEASES_HOME = RootRoutePaths.RELEASES_HOME;
}
